
<div class="state-container h-100">
    <h1>browser-state</h1>
    <p><label>appName: </label>{{ _navigator.appName }}</p>  
    <p><label>vendor: </label>{{ _navigator.vendor }}</p>    
    <p><label>user-agent: </label>{{ _navigator.userAgent }}</p>
    <p><label>camera permission: </label> {{ cameraPermission }}</p>   
    <p><label>connectionSaveData: </label>{{ _navigator && _navigator.connection && _navigator.connection.saveData }}</p>
    <p><label>cookieEnabled: </label>{{ _navigator &&_navigator.cookieEnabled }}</p>
    <p><label>language: </label>{{ _navigator &&_navigator.language }}</p>
    <p><label>languages: </label>{{ _navigator &&_navigator.languages }}</p>
    <p><label>platform: </label>{{ _navigator &&_navigator.platform }}</p>
    <p><label>product: </label>{{ _navigator &&_navigator.product }}</p>
    <p><label>productSub: </label>{{ _navigator.productSub }}</p>
    <p><label>oscpu: </label>{{ _navigator.oscpu }}</p>

    <p><label>Window InnerWidth: </label>{{ windowInnerWidth }}</p>
    <p><label>Window InnerHeight: </label>{{ windowInnerHeight }}</p>
    <p><label>Window OuterWidth: </label>{{ windowOuterWidth }}</p>
    <p><label>Window Outerheight: </label>{{ windowOuterHeight }}</p>
    
    <p><input #file type="file" multiple accept="image/*" multiple style="cursor: pointer;" (change)="onFileChange($event)"/></p>
    <p><button (click)="onCaptureImageClicked($event)">Open camera on click</button></p>

    <p><button (click)="onCaptureImageMouseUp($event)">Open camera on mouse up</button></p>
    <p><button (click)="onCaptureImageMouseDown($event)">Open camera on mouse down</button></p>
    <p><button (click)="onCaptureImageTouchStart($event)">Open camera on touch start</button></p>


    <p><button (click)="file.click()">Open camera  Simple click</button></p>

    <p>&nbsp;</p>
</div>

